import { render, staticRenderFns } from "./EduCourseCharpterTestpaper.vue?vue&type=template&id=cbab860a&scoped=true&"
import script from "./EduCourseCharpterTestpaper.vue?vue&type=script&lang=js&"
export * from "./EduCourseCharpterTestpaper.vue?vue&type=script&lang=js&"
import style0 from "./EduCourseCharpterTestpaper.vue?vue&type=style&index=0&id=cbab860a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab860a",
  null
  
)

export default component.exports